<template>
  <v-flex class="pa-1" data-qa="photoupload-flex-rw4xzf">
    <v-file-input
      v-model="files"
      @change="setData($event)"
      :label="$t('docUpload.selectFile')"
      accept="image/*"
      show-size
      :error="error"
      :color="primaryColor"
     data-qa="photoupload-file-input-652l5o"></v-file-input>
  </v-flex>
</template>

<script>
import '@/styles/components/fileUpload.scss'
import store from '@/core/store'
import event from '@/util/event'

export default {
  name: 'Photo-Upload',
  data () {
    return {
      files: [],
      urlPdf: undefined,
      enablePdfViewer: false,
      maxSize: this.$appSettings.defaultConfigurations.maxUploadPhotoSize,
      error: false,
      color: undefined,
      showPreview: true,
      isAcceptable: true
    }
  },
  methods: {
    setData (file) {
      this.error = false
      this.color = '#757575'

      if (file && file.name) {
        if (file && file.type.includes('image/')) {
          this.$emit('deleteClippedImg', undefined)
          if (Math.round(file.size / 1000) > this.maxSize) {
            this.files = []
            this.color = this.errorColor
            this.$store.dispatch('appStore/setAppData', {
              message: {
                content: this.$t('personalSettings.fileUpload.warning'),
                type: 'error',
                component: 'dob-snackbar',
                timeOut: 2000
              }
            })
            this.isAcceptable = false
          } else {
            this.color = '#757575'
            this.isAcceptable = true
            this.urlPdf = undefined
            this.enablePdfViewer = true
            this.urlPdf = URL.createObjectURL(file)
            event.$emit('selectedPhoto', this.urlPdf)
            store.dispatch('profileStore/setProfileData', {
              customerDoc: this.urlPdf,
              customerImageFileName: file.name,
              customerImageFileType: file.type
            })
          }
        } else {
          this.invalidateInputField(this.isAcceptable)
        }
      } else {
        this.invalidateInputField()
      }
      this.isAcceptable = false
    },
    invalidateInputField (fileTypeExists = true) {
      if (!fileTypeExists) {
        this.files = []
        this.$store.dispatch('appStore/setAppData', {
          message: {
            content: this.$t('personalSettings.fileUpload.invalidFile'),
            type: 'error',
            component: 'dob-snackbar',
            timeOut: 2000
          }
        })
      }
      this.files = []
      this.error = true
      this.color = this.errorColor
      this.isAcceptable = false
      event.$emit('photoSelected', false)
      store.dispatch('profileStore/setProfileData', { customerDoc: undefined })
    }
  },
  watch: {
    color () {
      event.$emit('isPhotoUploadError', this.color)
    },
    error () {
      if (this.error) {
        this.$emit('deleteClippedImg', undefined)
      }
    }
  }
}
</script>
